import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

function CommonConditions({ commonDrug = [], type }) {
  return (
    <section className="top-drugs">
      <article>
        <h2>Common conditions</h2>
        <ul>
          {commonDrug.map((item, id) => {
            return (
              <li key={id}>
                <a href={`/conditions/${item.conditionLink}`}>
                  <div className="imgColumn">
                    <LazyLoadImage
                      className="article-img"
                      src={item.thumbnailImage}
                      alt=""
                    />
                  </div>
                  {item.title}
                </a>
              </li>
            );
          })}
        </ul>
      </article>
      <div className="commonLinks">
        <a href={`/conditions-${type}`}>Browse {type} of common conditions</a> |{' '}
        <a href="/conditions-treatments">
          Browse treatments for common conditions
        </a>
      </div>
    </section>
  );
}

export default CommonConditions;
